// extracted by mini-css-extract-plugin
module.exports = {"fix_bottom":"fix_bottom-3xHocs4M","fix_follow":"fix_follow-384JQ4aC"};